import { useEffect, useState } from 'react';
import { isAfter } from 'date-fns';
import { usePleditor } from 'shared/domains/documents';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
export const useWorkflowCheckOutdated = () => {
    var _a;
    const { approvalResult, signatoryResult } = useWorkflowCheck();
    const { plugins } = usePleditor();
    const { versionDiagnostics } = plugins;
    const [documentUpdatedAt, setDocumentUpdatedAt] = useState((_a = versionDiagnostics === null || versionDiagnostics === void 0 ? void 0 : versionDiagnostics.updatedAt) !== null && _a !== void 0 ? _a : '');
    const isApprovalOutdated = approvalResult.isChecked && isAfter(documentUpdatedAt, approvalResult.checkedAt);
    const isSignatoryOutdated = signatoryResult.isChecked && isAfter(documentUpdatedAt, signatoryResult.checkedAt);
    useEffect(() => {
        var _a;
        if (versionDiagnostics) {
            const onUpdatedAtChanged = (evt, name, updatedAt) => {
                setDocumentUpdatedAt(updatedAt);
            };
            setDocumentUpdatedAt((_a = versionDiagnostics.updatedAt) !== null && _a !== void 0 ? _a : '');
            versionDiagnostics.on('change:updatedAt', onUpdatedAtChanged);
            return () => {
                versionDiagnostics.off('change:updatedAt', onUpdatedAtChanged);
            };
        }
        return undefined;
    }, [versionDiagnostics]);
    return { isApprovalOutdated, isSignatoryOutdated };
};
